import { z } from 'zod';

import { TypeSegment } from '../models/contentful-generated';
import { ContentfulAssetSchema } from './contentful-asset.validator';
import { ContentfulDocumentSchema } from './contentful-document.validator';
import { ContentfulSysSchema } from './contentful-sys.validator';
import { IndustryEntrySchema } from './industry.validator';
import { SynonymEntrySchema } from './synonym.validator';

export const SegmentEntrySchema = z.object({
  sys: ContentfulSysSchema,
  fields: z.looseObject({
    name: z.string(),
    industry: IndustryEntrySchema.optional().nullable(),
    applications: z.array(z.string()).optional().nullable(),
    rank: z.number().int(),
    image: ContentfulAssetSchema.optional().nullable(),
    description: ContentfulDocumentSchema.optional().nullable(),
    synonyms: z.array(SynonymEntrySchema).optional().nullable()
  }),
  metadata: z
    .object({
      tags: z.array(z.any()).optional().nullable()
    })
    .optional()
    .nullable()
});

export function validateSegmentEntry(data: TypeSegment) {
  return SegmentEntrySchema.safeParse(data);
}

/**
 * Returns validation result.
 *
 * @param data
 */
export function validateSegmentEntries(data: TypeSegment[]) {
  return z.array(SegmentEntrySchema).safeParse(data);
}

/**
 * Returns valid entries only. In most cases, this is preferred,
 * It allows us to still show some entries instead of showing nothing when only a single entry is invalid.
 *
 * @param data
 */
export function validateAndFilterSegmentEntries(data: TypeSegment[]) {
  if (!data) return [];

  return data.reduce((acc: TypeSegment[], entry) => {
    const validationResult = validateSegmentEntry(entry);
    if (validationResult.success) {
      acc.push(validationResult.data as unknown as TypeSegment);
    } else {
      console.warn(
        `Validation failed for segment entry with id: '${entry?.sys?.id}'. It will be filtered out. Error: ${validationResult.error.message}`
      );
    }
    return acc;
  }, []);
}
